import ParkPassAPI from "../parkpassAxiosConfig";

export const getAdminFatouratiPayments = async (params = {}) => {
  try {
    const {
      page = 1,
      pageSize = 25,
      statusFilter,
      productType,
      userId,
      search,
    } = params;

    const queryParams = { page, page_size: pageSize };
    if (statusFilter) queryParams.status_filter = statusFilter;
    if (productType) queryParams.product_type = productType;
    if (userId) queryParams.user_id = userId;
    if (search) queryParams.search = search;

    const response = await ParkPassAPI.get("/v1/wallet/admin/fatourati", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
